import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router";
import { templateBuilderMutations } from "@/features/template-builder/mutations";
import { templateBuilderQueries } from "@/features/template-builder/queries";

export function useDeleteTemplate(templateId: string) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      await templateBuilderMutations.deleteTemplate(templateId);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(templateBuilderQueries.lists());
      void navigate("/template-builder");
    },
  });
}
